import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import api from '../utils/httpClient';
interface UserMe {
  CareUserID: string;
  AccountID: string;
  Email: string;
  UserImageUrl: string;
  UserImageThumb: string;
  FirstName: string;
  LastName: string;
  VideoCallShortcut: boolean;
  AudioCallShortcut: boolean;
  BargeInCallShortcut: boolean;
  SilentBargeInCallShortcut: boolean;
  UserBargeInEnabled: boolean;
  AutomaticCallRequestBargeIn: boolean;
  IsOnDuty: boolean;
  IsAdmin: boolean;
  Created: boolean;
  OnlyUrgent: boolean;
  Telephone: string;
  CanSeeClientsTab: boolean;
  CanSeeMessageCenterTab: boolean;
  CanSeeQueueTab: boolean;
  CanSeeMemoryBox: boolean;
  CanSeeBulletinBoard: boolean;
  CanSeeAlertsTab: boolean;
  CanSeeStaffTab: boolean;
  CanDeletePatients: boolean;
  CanDeleteDevices: boolean;
  CanSeeDevicesTab: boolean;
  CanSeeVideoSessionTab: boolean;
  CanRestartDevices: boolean;
  BargeInCall: boolean;
  CanSendMessageToAllPatients: boolean;
  AccountAdmin: boolean;
  CaregiverRoleName: string;
  ClientRoleName: string;
  UserRoleName: string;
  CaregiverRoleNamePlural: string;
  ClientRoleNamePlural: string;
  UserRoleNamePlural: string;
  CompanyName: string;
  CompanyLogo: string;
  UsePanicEmergencyRingtone: boolean;
  EnableControlIncomingCall: boolean;
  EnableAutoAnswer: boolean;
  ShowEmergencyButton: boolean;
  ShowFamilyCallButton: boolean;
  EnableRingOnIncomingCall: boolean;
  EnableBiometrics: boolean;
  ShowVideoStats: boolean;
  MobileCallResponse: string;
  LocaleTag: string;
  MemoryBoxButtonText: string;
  IsHipaaCompliant: boolean;
  AutoLogoutTimeout: number;
  Format12Hrs: boolean;
  TwoFactorAuth: boolean;
  Region: string;
  Provider: string;
}

export interface InitialState {
  saving: boolean;
  error: string;
  success: boolean;
  data: UserMe | null;
}

const initialState: InitialState = {
  saving: false,
  error: '',
  success: false,
  data: null,
};

export const userMe = () => {
  return api.get(`/user/me`);

}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    reset: () => initialState,
    setUser: (state, action: PayloadAction<UserMe>) => {
      state.saving = false;
      state.success = true;
      state.error = '';
      state.data = action.payload;
    },
    setError: (state) => {
      state.saving = false;
      state.success = false;
      state.error = 'Unable to get user';
    },
    setPending: (state) => {
      state.saving = true;
      state.success = false;
      state.error = '';
    },
  },
});

export const { reset, setUser, setError, setPending } = userSlice.actions;
export default userSlice;
